import React from 'react';
import { Layout, Flex, Button, Tooltip, Input } from 'antd';
import { FilterOutlined, ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import AgentSelect from '../AgentSelect/AgentSelect';
import { useTheme } from '../../../Shared/GlobalContext/ThemeContext';

const { Header } = Layout;

const ConversationsHeader = ({
    agents,
    loadingAgents,
    selectedAgent,
    onAgentChange,
    onAgentSearch,
    onOpenFilters,
    onResetFilters,
    onSearch,
    loading,
}) => {
    const { isDarkMode } = useTheme();
    const { t } = useTranslation();
    const themeColors = {
        background: isDarkMode ? '#1f1f1f' : '#fff',
        border: isDarkMode ? '#434343' : '#f0f0f0',
        text: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)',
        secondaryText: isDarkMode ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.45)',
        hoverBg: isDarkMode ? '#2a2a2a' : '#fafafa',
    };

    return (
        <Header style={{
            padding: '8px',
            height: 'auto',
            lineHeight: 'normal',
            background: themeColors.background,
            borderBottom: `1px solid ${themeColors.border}`,
            transition: 'background 0.3s ease, border-color 0.3s ease'
        }}>
            {/* Agent Select */}
            <AgentSelect
                agents={agents}
                loading={loadingAgents}
                value={selectedAgent}
                onChange={onAgentChange}
                onSearch={onAgentSearch}
                isDarkMode={isDarkMode}
            />

            {/* Search Input */}
            <Input.Search
                placeholder={t('search_by_contact_name')}
                style={{
                    marginTop: '10px',
                    backgroundColor: isDarkMode ? '#141414' : '#fff',
                    borderColor: themeColors.border,
                    color: themeColors.text
                }}
                onChange={onSearch}
                loading={loading}
                allowClear
            />

            {/* Filters and Reset Buttons */}
            <Flex wrap>
                <Flex style={{ flexGrow: 1 }}>
                    <Button
                        type="link"
                        onClick={onOpenFilters}
                        icon={<FilterOutlined style={{ color: '#1890ff' }} />}
                        style={{
                            padding: '4px 0 0 0',
                            color: '#1890ff',
                            ':hover': {
                                backgroundColor: themeColors.hoverBg
                            }
                        }}
                    >
                        {t('advanced_filters')}
                    </Button>
                </Flex>
                <Tooltip title={t('reset_filters')}>
                    <Button
                        type="link"
                        icon={<ReloadOutlined style={{ color: '#1890ff' }} />}
                        onClick={onResetFilters}
                        style={{
                            padding: '4px 0 0 0',
                            marginInlineStart: '10px',
                            color: '#1890ff',
                            ':hover': {
                                backgroundColor: themeColors.hoverBg
                            }
                        }}
                    />
                </Tooltip>
            </Flex>
        </Header>
    );
};

export default ConversationsHeader;
